export const augmentUserData = (users = [], keycloakUsers = []) => users?.map((user) => {
  const keycloakUserData = keycloakUsers?.length ? keycloakUsers.find(keycloakUser => keycloakUser.id === user.userId) || {} : {}

  return {
    ...user,
    ...keycloakUserData
  };
})
